import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'components/Dropdown/Dropdown';
// import Datetime from 'react-datetime';
import Moment from 'moment';
import moment from 'moment-timezone';
import './style.scss';
// import { AppSettings } from '../../constants';

/*
 *https://github.com/Adphorus/react-date-range
 */

// const setToCurrentTime = value => {
//   return value.set({
//     hour: Moment().hour(),
//     minute: Moment().minute(),
//     second: Moment().second()
//   });
// };

export class DateFilterDashboard extends Component {
  static propTypes = {
    className: PropTypes.string,
    onSave: PropTypes.func,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    optionType: PropTypes.string,
    defaultValue: PropTypes.string
  };

  constructor(props) {
    super(props);

    this.options = [
      { key: 0, value: 'Last 24 hours', extensionValue: {name: 'duration', sso: true} },
      { key: 1, value: 'Last 7 days' , extensionValue: {name: 'duration', sso: true} },
      { key: 2, value: 'Today' , extensionValue: {name: 'day', sso: false} },
      { key: 3, value: 'Yesterday' , extensionValue: {name: 'day', sso: false} }
    ];

    this.initialValue = null;

    if (props.defaultValue) {
      this.initialValue = this.options[0];
    }
    if (props.startDate && props.endDate) {
      this.initialValue = this.options[0];
    }

    if (props.optionType) {
      this.initialValue = this.options.find(x => x.value === props.optionType);
    }

    this.state = {
      value: this.initialValue,
      valueStartDate: null,
      valueEndDate: null,
      fromDate: props.startDate ? Moment(props.startDate) : null,
      toDate: props.endDate ? Moment(props.endDate) : null,
      options: this.options,
      isDisplayPopupCustomValue: false,
      isOpenFromDate: true,
      error: null
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleHideDateRange);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      isKeepShow: false,
      isDisplayPopupCustomValue: false
    });

    // if (
    //   nextProps.startDate !== this.props.startDate ||
    //   nextProps.endDate !== this.props.endDate
    // ) {
    //   const newOptions = [...this.state.options];
    //   newOptions[4].label =
    //     Moment(nextProps.startDate).format('MM/DD/YYYY') +
    //     ' - ' +
    //     Moment(nextProps.endDate).format('MM/DD/YYYY');

    //   let newValue = null;

    //   if (nextProps.endDate) {
    //     newValue = nextProps.optionType
    //       ? newOptions.find(x => x.value === nextProps.optionType)
    //       : newOptions[4];
    //   }
    //   this.setState({
    //     fromDate: nextProps.startDate ? Moment(nextProps.startDate) : null,
    //     toDate: nextProps.endDate ? Moment(nextProps.endDate) : null,
    //     options: nextProps.endDate ? newOptions : this.options,
    //     value: newValue
    //   });
    // }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleHideDateRange);
  }

  callbackSelectDate = key => {
    let startDate = null;
    let endDate = null;
    if (key === 0) {
      //last 24 hours
      startDate = moment
        .utc().subtract(24, 'hours')
        .local()
        .format();
      endDate = moment
        .utc()
        .local()
        .format();
    } else if (key === 1) {
      //last 7 days
      startDate = moment
        .utc().subtract(7, 'days')
        .local()
        .set({ hour: 0, minute: 0, second: 0 })
        .format();
      endDate = moment
        .utc()
        .local()
        .set({ hour: 23, minute: 59, second: 59 })
        .format();
    } else if (key === 2) {
      //today
      startDate = moment
        .utc()
        .local()
        .set({ hour: 0, minute: 0, second: 0 })
        .format();
      endDate = moment
        .utc()
        .local()
        .set({ hour: 23, minute: 59, second: 59 })
        .format();
    } else if (key === 3) {
      //yesterday
      startDate = moment
        .utc()
        .local()
        .set({ hour: 0, minute: 0, second: 0 }).subtract(24, 'hours')
        .format();
      endDate = moment
        .utc()
        .local()
        .set({ hour: 23, minute: 59, second: 59 }).subtract(24, 'hours')
        .format();
    }

    this.props.onSave(startDate, endDate, this.state.value);
  };

  onSelectChange = e => {
    this.setState(
      {
        value: e.value,
        fromDate: null,
        toDate: null,
        error: null
      },
      () => {
        this.callbackSelectDate(e.value ? e.value.key : null);
      }
    );
  };

  handleHideDateRange = event => {
    if (this.state.isDisplayPopupCustomValue) {
      if (!this.customRange.contains(event.target)) {
        this.setState({
          isKeepShow: false,
          isDisplayPopupCustomValue: false,
          error: null
        });
        if (
          !this.state.value ||
          (this.state.value &&
            this.state.value.key !== 4 &&
            this.state.valueStartDate &&
            this.state.valueEndDate)
        ) {
          this.setState({
            fromDate: null,
            toDate: null
          });
        }
      } else {
        this.setState({
          isKeepShow: true
        });
      }
    }
  };

  onReset = () => {
    this.setState(
      {
        value: null
      },
      () => {
        this.callbackSelectDate(null);
      }
    );
  };

  render() {
    return (
      <div className='custom-date-range'>
        <div className={this.props.className} style={{ padding: 0 }}>
          <Dropdown
            onChange={this.onSelectChange}
            className='filestring-dropdown filter-dropdown'
            options={this.state.options}
            optionLabel='value'
            value={this.state.value}
            placeholder='Any time'
            style={{ width: '100%' }}
            // showClear={true}
            groupLabels={[
              {
                label: 'Duration',
                field: 'sso',
                condition: [true]
              },
              {
                label: 'Day',
                field: 'sso',
                condition: [false, null]
              }
            ]}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/date-filter-dashboard/index.js